<template>
    <div>
        {{
            redirect ? $router.replace({ path: `/v2/profile/${userId}` }) : null
        }}
    </div>
</template>

<script>
import { getUserData } from '@/services/user-data'

export default {
    name: 'Home',
    data() {
        return {
            userId: getUserData().id,
        }
    },
    computed: {
        redirect() {
            return !!this.userId
        },
    },
}
</script>
